import { render, staticRenderFns } from "./LayoutHome.vue?vue&type=template&id=cf2be06a&scoped=true&lang=pug"
import script from "./LayoutHome.vue?vue&type=script&lang=js"
export * from "./LayoutHome.vue?vue&type=script&lang=js"
import style0 from "./LayoutHome.vue?vue&type=style&index=0&id=cf2be06a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf2be06a",
  null
  
)

export default component.exports